export default "__VITE_ASSET__44e68fe8__"